import ApiService from "@/services/ApiService";
import { serialize } from '@/utils/helper';
export default {
  getGolfCourse(page, limit) {
    return ApiService().get(`/courses?page=${page}&limit=${limit}`);
  },
  getFollow(page) {
    return ApiService().get(`/follow/following?page=${page}`);
  },
  getFollowByUser(key) {
    return ApiService().get(`/follow/following/${key}`);
  },
  setFollow(data) {
    return ApiService().post("/follow", data, true);
  },
  setUnFollow(data) {
    return ApiService().delete(`/follow/${data.entityName}/${data.entityId}`,null, true);
  },
  setUnFollowUser(key) {
    return ApiService().delete("/follow/user/" + key);
  },
};
